import { ColumnConfig, ColumnDataType } from '@aurora';

export const chartTypeColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.STRING,
        field: 'value',
        sort: 'value',
        translation: 'digitai.Value',
        isUnaccent: true,
    },
];
